import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Grid } from "@mui/material";

import rmsActions from "../../../../actions/rmsActions";
import { getUser, getTasks, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import TaskCard from "./TaskCard";
import BreadcrumbBuilder from "../BreadcrumbBuilder";


function TaskList() {
    const dispatch = useDispatch();

    const appCode = useSelector(getRmsAppCode);
    const isFetchingTasks = useSelector((state) => isFetching(state, DataTypes.TASKS));
    const tasks = useSelector((state) => getTasks(state));
    const user = useSelector((state) => getUser(state));

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getTasks(appCode));
        }
    }, [dispatch, appCode]);

    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetchingTasks && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!!tasks && Array.isArray(tasks) &&
                    tasks
                        .sort((a, b) => (a.priority >= b.priority ? 1 : -1))
                        .map((task) => (
                            <Grid item md={12} lg={6} key={task.uuid} className="card-grid-item" >
                                <TaskCard task={task} owner={user.uuid} />
                            </Grid>
                        ))
                }
            </Grid>
        </Container>
    );
}

export default TaskList;
